module.exports = __webpack_public_path__ + "assets/img/37_335.27f1160b.jpg";